module.exports = __webpack_public_path__ + "img/dr_10.b421b627.png";